import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Church = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m3.5 15.5 5-2V10m-1 .5 4.5-4 4.5 4m4 5-5-2V10m-11 5.5V21a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5v-5.5M12.72 3a.7.7 0 0 0-.433.155.9.9 0 0 0-.287.41.9.9 0 0 0-.287-.41.7.7 0 0 0-.434-.155.82.82 0 0 0-.558.324c-.145.186-.224.43-.22.68C10.5 5.106 11.8 6 12 6s1.5-.895 1.5-1.995a1.1 1.1 0 0 0-.221-.682A.82.82 0 0 0 12.72 3M12 14.5a2.5 2.5 0 0 1 2.5 2.5v4.5h-5V17a2.5 2.5 0 0 1 2.5-2.5"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Church) as SvgIcon;
export { ForwardRef as ReactComponent };
